
export default{
    name: "toggle",
    _source: null,
    _target: null,

    init() {
        this._source = document.querySelectorAll('[data-toggle-source]');
        this._target = document.querySelectorAll('[data-toggle-target]');

        if(!(this._source)){
            return;
        }

        for(const source of this._source){
            source.addEventListener('click',(e)=>{
                console.log(source);
                e.preventDefault();
                const toggleStd = source.getAttribute('data-toggle-source');
                const target = document.querySelector('[data-toggle-target="' + toggleStd + '"]');
                if(target){
                    if(source.classList.contains('hamburger')){
                        source.classList.toggle('is-active');
                    }
                    target.classList.toggle(target.classList[0] + '--active');
                    source.classList.toggle(source.classList[0] + '--active');
                }
            })
        }

    }
}
